import React from "react";
import { motion } from "framer-motion";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Partnerships() {
  const partnerLogos = [
    "/assets/1.png",
    "/assets/2.webp",
    "/assets/3.webp",
    "/assets/4.jpg",
    "/assets/5.png",
    "/assets/6.png",
    "/assets/7.jpg",
    "/assets/8.jpg",
    "/assets/9.jpg",
    "/assets/10.webp",
    "/assets/11.jpg",
    "/assets/12.png",
    "/assets/13.webp",
    "/assets/14.png",
    "/assets/15.png",
    "/assets/16.webp",
    "/assets/17.png",
    "/assets/18.jpg",
    "/assets/19.png",
    "/assets/20.png",
    "/assets/21.png",
    "/assets/22.webp",
    "/assets/23.webp",
  ];

  // Settings for a smooth, continuous premium marquee ticker
  const sliderSettings = {
    dots: false,
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    speed: 3500,
    autoplaySpeed: 0,
    cssEase: "linear",
    pauseOnHover: false,
    arrows: false,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2, // 2 items looks clean on mobile when they are appropriately sized
        },
      },
    ],
  };

  return (
    <section
      id="partnerships"
      className="py-20 md:py-28 px-4 md:px-8 bg-white border-b border-gray-100"
    >
      <div className="container mx-auto max-w-7xl">
        <div className="flex flex-col md:flex-row items-center justify-between mb-16 md:mb-24">
          <div className="w-full md:w-1/2 text-center md:text-left mb-10 md:mb-0">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, ease: "easeOut" }}
              className="inline-block px-4 py-1.5 rounded-full bg-blue-50 text-blue-600 font-semibold text-sm tracking-wide mb-6"
            >
              Trusted Partners
            </motion.div>
            <motion.h2
              className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 mb-6 leading-tight"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, ease: "easeOut", delay: 0.1 }}
            >
              Powered by <br className="hidden md:block" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600">
                Fino Payments Bank
              </span>
            </motion.h2>
            <motion.p
              className="text-lg md:text-xl text-gray-500 leading-relaxed max-w-lg mx-auto md:mx-0"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.3, duration: 0.6, ease: "easeOut" }}
            >
              As a Business Correspondent, we bring you the trust, security, and reliability of a leading name in the Indian banking sector.
            </motion.p>
          </div>

          <div className="w-full md:w-1/2 flex justify-center md:justify-end">
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 0.4, duration: 0.6, ease: "easeOut" }}
              className="w-full max-w-xs p-8 md:p-10 bg-white rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-gray-50 flex items-center justify-center"
            >
              <img
                src="/assets/Fino.png"
                alt="Fino Payments Bank Logo"
                className="w-full h-auto object-contain max-h-20"
              />
            </motion.div>
          </div>
        </div>

        {/* Ticker Section */}
        <div className="pt-6">
          <p className="text-center text-sm font-semibold text-gray-400 uppercase tracking-widest mb-8">
            Integrated With Top Service Providers
          </p>
          <div className="rounded-2xl overflow-hidden relative">
            {/* Soft gradient masks covering edge spillover */}
            <div className="absolute left-0 top-0 bottom-0 w-8 md:w-32 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none"></div>
            <div className="absolute right-0 top-0 bottom-0 w-8 md:w-32 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none"></div>
            
            <Slider {...sliderSettings}>
              {partnerLogos.map((logo, index) => (
                <div key={index} className="px-2 md:px-4 py-4 outline-none flex justify-center items-center">
                  {/* Sizing wrapper scales up cleanly across devices */}
                  <div className="w-full flex justify-center items-center h-20 md:h-24">
                    <img
                      src={logo}
                      alt={`Partner Logo ${index + 1}`}
                      className="h-full w-auto max-h-14 sm:max-h-16 md:max-h-20 max-w-[140px] sm:max-w-[160px] object-contain mx-auto filter grayscale opacity-75 hover:grayscale-0 hover:opacity-100 transition-all duration-300 cursor-pointer"
                    />
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Partnerships;